import { useState, useEffect, useContext } from 'react';
import { AppContext } from '../App';

export default function SwipeTabs(props) {
  const appContext = useContext(AppContext);
  const [ tabs, setTabs ] = useState(props.tabs);

  const scrollTop = () => {
    document.getElementById('_fullPane1').scrollTo({
     top: 0,
     behavior: "smooth"
   });
  }

  useEffect(() => {
    setTabs(props.tabs);
  }, [ props.tabs ]);

  return (
    <>
      <div className="TabPills" data-support-topbarmain={props.support_topbarmain}>
        <ul className="nav nav-pills d-flex justify-content-between container" id="pills-tab" role="tablist" style={{ height: "100%", padding: "0px", gap: "10px" }}>
          {
            tabs.map((item, i) => {
              if(i === 0) {
                return (
                  <li className="nav-item align-self-center" role="presentation" key={i} onClick={scrollTop}>
                    <button className="nav-link mOneLineText active" id={"pills-"+item.id+"-tab"} data-bs-toggle="pill" data-bs-target={"#pills-"+item.id} type="button" role="tab" aria-controls={"pills-"+item.id} aria-selected="true">{item.title}</button>
                  </li>
                );
              } else {
                return (
                  <li className="nav-item align-self-center" role="presentation" key={i} onClick={scrollTop}>
                    <button className="nav-link mOneLineText" id={"pills-"+item.id+"-tab"} data-bs-toggle="pill" data-bs-target={"#pills-"+item.id} type="button" role="tab" aria-controls={"pills-"+item.id} aria-selected="false">{item.title}</button>
                  </li>
                )
              }
            })
          }
        </ul>
      </div>


      <div className="tab-content container" id="pills-tabContent" style={{ paddingTop: "var(--topBarheight)", paddingBottom: "var(--topBarheight)" }}>
        {
          tabs.map((item, i) => {
            if(i === 0) {
              return (
                <div className="tab-pane fade show active" id={"pills-"+item.id} role="tabpanel" aria-labelledby={"pills-"+item.id+"-tab"} key={i}>
                  {item.view}
                </div>
              );
            } else {
              return (
                <div className="tab-pane fade show" id={"pills-"+item.id} role="tabpanel" aria-labelledby={"pills-"+item.id+"-tab"} key={i}>
                  {item.view}
                </div>
              );
            }
          })
        }
      </div>
    </>
  )
}
